import { Box } from '@mui/material'
import { homeMobilePaddingX } from '../components/home/homeMobileLayout'
import HeroSection from '../components/home/HeroSection'
import HomeScrollExperience from '../components/home/HomeScrollExperience'
import IndiaMapDimensions from '../components/home/IndiaMapDimensions'
import OurStorySection from '../components/home/OurStorySection'
import VideoSection from '../components/common/VideoSection'
import StatsSection from '../components/common/StatsSection'
import HighlightVideoBanner from '../components/home/HighlightVideoBanner'
import KeyInitiativesSection from '../components/home/KeyInitiativesSection'
import PlcPreviewSection from '../components/home/PlcPreviewSection'
import InspiringStoriesSection from '../components/home/InspiringStoriesSection'
import UpcomingEventsSection from '../components/home/UpcomingEventsSection'
import LatestStoriesSection from '../components/home/LatestStoriesSection'
import PastEventsGallery from '../components/home/PastEventsGallery'
import VolunteerBanner from '../components/common/VolunteerBanner'
import ExperiencesThatInspireSection from '../components/home/ExperiencesThatInspireSection'

export default function HomePage() {
  return (
    <Box>
      <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
        <HeroSection />
        <IndiaMapDimensions />
      </Box>

      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <HomeScrollExperience />
      </Box>

      <OurStorySection />

      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          width: '100%',
          maxWidth: 1920,
          mx: 'auto',
          px: homeMobilePaddingX,
          py: { xs: 6, md: 8, lg: 10 },
          boxSizing: 'border-box',
        }}
      >
        <VideoSection />
      </Box>

      <StatsSection />
      <KeyInitiativesSection />
      <HighlightVideoBanner enableScrollZoom />
      <PlcPreviewSection />
      <InspiringStoriesSection />
      <UpcomingEventsSection />
      <LatestStoriesSection />

      <PastEventsGallery />

      <ExperiencesThatInspireSection />

      <Box
        sx={{
          width: '100%',
          maxWidth: 1920,
          mx: 'auto',
          px: homeMobilePaddingX,
          pb: { xs: 6, sm: 8, lg: '150px' },
          boxSizing: 'border-box',
        }}
      >
        <VolunteerBanner />
      </Box>
    </Box>
  )
}
